module.exports = __webpack_public_path__ + "static/media/6_placeholder_it.c4a9069b.png";